export const Types = {
  //Get - List
  GET_ADMINISTRATORS_LIST_REQUEST: 'GET_ADMINISTRATORS_LIST_REQUEST',
  GET_ADMINISTRATORS_LIST_SUCCESS: 'GET_ADMINISTRATORS_LIST_SUCCESS',
  GET_ADMINISTRATORS_LIST_FAIL: 'GET_ADMINISTRATORS_LIST_FAIL',

  //Set for Update list
  SET_UPDATE_ADMINISTRATORS_LIST: 'SET_UPDATE_ADMINISTRATORS_LIST',

  //Store - Add
  POST_ADMINISTRATORS_ADD_REQUEST: 'POST_ADMINISTRATORS_ADD_REQUEST',
  POST_ADMINISTRATORS_ADD_SUCCESS: 'POST_ADMINISTRATORS_ADD_SUCCESS',
  POST_ADMINISTRATORS_ADD_FAIL: 'POST_ADMINISTRATORS_ADD_FAIL',

  //Update - Edit
  PUT_ADMINISTRATORS_EDIT_REQUEST: 'PUT_ADMINISTRATORS_EDIT_REQUEST',
  PUT_ADMINISTRATORS_EDIT_SUCCESS: 'PUT_ADMINISTRATORS_EDIT_SUCCESS',
  PUT_ADMINISTRATORS_EDIT_FAIL: 'PUT_ADMINISTRATORS_EDIT_FAIL',

  //Delete
  DELETE_ADMINISTRATORS_DEL_REQUEST: 'DELETE_ADMINISTRATORS_DEL_REQUEST',
  DELETE_ADMINISTRATORS_DEL_SUCCESS: 'DELETE_ADMINISTRATORS_DEL_SUCCESS',
  DELETE_ADMINISTRATORS_DEL_FAIL: 'DELETE_ADMINISTRATORS_DEL_FAIL',

  //CLear 
  CLEAR_ALL_REQUEST: 'CLEAR_ALL_REQUEST',
};

const INITIAL_STATE = {
  dataList: [],
  loadingList: false,
  errorList: false,
  errorDataList: false,
  dataListUpdate: false,

  loadingAdd: false,
  errorAdd: false,
  errorDataAdd: false,

  loadingEdit: false,
  errorEdit: false,
  errorDataEdit: false,

  loadingDelete: false,
  errorDelete: false,
  errorDataDelete: false,

};

export default function administrators(state = INITIAL_STATE, action) {
  switch (action.type) {
    //Get - List
    case Types.GET_ADMINISTRATORS_LIST_REQUEST:
      return {
        ...state,
        loadingList: true,
        errorList: false,
      };
    case Types.GET_ADMINISTRATORS_LIST_SUCCESS:
      return {
        ...state,
        dataList: action.payload,
        loadingList: false,
        errorList: false,
        errorDataList: false
      };
    case Types.GET_ADMINISTRATORS_LIST_FAIL:
      return {
        ...state,
        dataList: false,
        loadingList: false,
        errorList: true,
        errorDataList: action.payload,
      };

    case Types.SET_UPDATE_ADMINISTRATORS_LIST:
      return {
        ...state,
        dataListUpdate: action.payload,
      };

    //Store - Add
    case Types.POST_ADMINISTRATORS_ADD_REQUEST:
      return {
        ...state,
        loadingAdd: true,
        errorAdd: false,
      };
    case Types.POST_ADMINISTRATORS_ADD_SUCCESS:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,
      };
    case Types.POST_ADMINISTRATORS_ADD_FAIL:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: true,
        errorDataAdd: action.payload,
      };

    //Update - Edit
    case Types.PUT_ADMINISTRATORS_EDIT_REQUEST:
      return {
        ...state,
        loadingEdit: true,
        errorEdit: false,
      };
    case Types.PUT_ADMINISTRATORS_EDIT_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,
      };
    case Types.PUT_ADMINISTRATORS_EDIT_FAIL:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: true,
        errorDataEdit: action.payload,
      };

    //Delete 
    case Types.DELETE_ADMINISTRATORS_DEL_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        errorDelete: false,
      };
    case Types.DELETE_ADMINISTRATORS_DEL_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,
      };
    case Types.DELETE_ADMINISTRATORS_DEL_FAIL:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: true,
        errorDataDelete: action.payload,
      };

    //Clear
    case Types.CLEAR_ALL_REQUEST:
      return {
        ...state,

        dataList: false,
        loadingList: false,
        errorList: false,
        errorDataList: false,
        dataListUpdate: false,

        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,

        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,

        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,

      };

    default:
      return state;
  }
}

export const Creators = {

  //Get - List
  getAdministratorsListRequest: (payload) => ({
    type: Types.GET_ADMINISTRATORS_LIST_REQUEST,
    payload,
  }),
  getAdministratorsListRequestSuccess: (payload) => ({
    type: Types.GET_ADMINISTRATORS_LIST_SUCCESS,
    payload,
  }),
  getAdministratorsListRequestFail: (payload) => ({
    type: Types.GET_ADMINISTRATORS_LIST_FAIL,
    payload,
  }),

  setUpdateAdministrators: (payload) => ({
    type: Types.SET_UPDATE_ADMINISTRATORS_LIST,
    payload,
  }),


  //Store - Add 
  postAdministratorsAddRequest: (payload) => ({
    type: Types.POST_ADMINISTRATORS_ADD_REQUEST,
    payload,
  }),
  postAdministratorsAddRequestSuccess: () => ({
    type: Types.POST_ADMINISTRATORS_ADD_SUCCESS,
  }),
  postAdministratorsAddRequestFail: (payload) => ({
    type: Types.POST_ADMINISTRATORS_ADD_FAIL,
    payload,
  }),

  //Update - Edit 
  putAdministratorsEditRequest: (payload) => ({
    type: Types.PUT_ADMINISTRATORS_EDIT_REQUEST,
    payload,
  }),
  putAdministratorsEditRequestSuccess: () => ({
    type: Types.PUT_ADMINISTRATORS_EDIT_SUCCESS,
  }),
  putAdministratorsEditRequestFail: (payload) => ({
    type: Types.PUT_ADMINISTRATORS_EDIT_FAIL,
    payload,
  }),

  //Delete 
  deleteAdministratorsDelRequest: (payload) => ({
    type: Types.DELETE_ADMINISTRATORS_DEL_REQUEST,
    payload,
  }),
  deleteAdministratorsDelRequestSuccess: () => ({
    type: Types.DELETE_ADMINISTRATORS_DEL_SUCCESS,
  }),
  deleteAdministratorsDelRequestFail: (payload) => ({
    type: Types.DELETE_ADMINISTRATORS_DEL_FAIL,
    payload,
  }),

  //Clear
  clearAllRequest: () => ({
    type: Types.CLEAR_ALL_REQUEST
  }),
};
